import dashboard from './dashboard';
import components from './components';
import system from './system';
import pages from './pages';

const menuItems = {
  items: [dashboard, pages, components, system],
};

export default menuItems;
